// pages/LuxotticaRegisterPage.jsx (or any page file)
import React from 'react';
import RegisterPage from '../components/RegisterPage'; // Adjust path based on your folder structure
import config from '@/config';
import { buildPath } from '@/utils/routeBuilder';

const IconicRegisterPage = () => {
  return (
    <RegisterPage 
      projectId="iconic"
      projectName="Iconic"
      loginPath={buildPath('/iconic/login')}
      brandColor="blue"
      apiUrl={config.AUTH_API_ADDRESS} // Optional, defaults to this
    />
  );
};

export default IconicRegisterPage;